import { render, staticRenderFns } from "./Ourlab.vue?vue&type=template&id=54c94b6c&scoped=true&"
import script from "./Ourlab.vue?vue&type=script&lang=js&"
export * from "./Ourlab.vue?vue&type=script&lang=js&"
import style0 from "./Ourlab.vue?vue&type=style&index=0&id=54c94b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c94b6c",
  null
  
)

export default component.exports